module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-4 title"
  }, [_vm._v("\n      Select staff\n      "), _c('v-spacer')], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "row": "",
      "wrap": ""
    }
  }, [(_vm.servicesList.length > 0) ? _c('v-flex', [_c('v-checkbox', {
    attrs: {
      "label": "Preplan"
    },
    model: {
      value: (_vm.isPreplan),
      callback: function($$v) {
        _vm.isPreplan = $$v
      },
      expression: "isPreplan"
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm._f("filterCaseManagers")(_vm.servicesList),
      "label": "Select case manager"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n              ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n              ")]
      }
    }], null, false, 2095008220),
    model: {
      value: (_vm.selectedCaseManager.id),
      callback: function($$v) {
        _vm.$set(_vm.selectedCaseManager, "id", $$v)
      },
      expression: "selectedCaseManager.id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-select', {
    attrs: {
      "disabled": _vm.isPreplan,
      "items": _vm._f("filterPalBearers")(_vm.servicesList),
      "item-text": "description",
      "attach": "",
      "chips": "",
      "multiple": "",
      "label": "Select pallbearers"
    },
    on: {
      "input": _vm.limiter
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n              ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n                    " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n                  ")])])]
      }
    }], null, false, 1132691999),
    model: {
      value: (_vm.selectedPalbearers),
      callback: function($$v) {
        _vm.selectedPalbearers = $$v
      },
      expression: "selectedPalbearers"
    }
  })], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": "#ff5353",
      "multi-line": "",
      "top": "",
      "right": "",
      "timeout": 6000
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n            You can select no more than three\n            "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("\n              Close\n            ")])], 1)], 1) : _c('v-flex', [_vm._v("Loading...")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": "",
      "align-left": "",
      "justify-space-between": ""
    }
  }, [_c('v-menu', {
    model: {
      value: (_vm.menuDateStart),
      callback: function($$v) {
        _vm.menuDateStart = $$v
      },
      expression: "menuDateStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.timeStart),
      callback: function($$v) {
        _vm.timeStart = $$v
      },
      expression: "timeStart"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "outline": "",
      "label": "Details about the upcoming venue"
    },
    model: {
      value: (_vm.venueDescription),
      callback: function($$v) {
        _vm.venueDescription = $$v
      },
      expression: "venueDescription"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary",
      "loading": _vm.loading.saveNewBtn
    },
    on: {
      "click": _vm.saveNew
    }
  }, [_vm._v("Notify staff")])], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7369511b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddLeadFormOld.vue
// module id = 985
// module chunks = 1